import { hotTicker } from "@/mocks/site";
import { Link } from "react-router-dom";

export default function HotTicker() {
  const items = [...hotTicker, ...hotTicker];

  return (
    <section aria-label="热门讨论实时滚动" className="bg-primary-500">
      <div className="flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-8 py-3.5 bg-primary-700 text-background-50 text-sm font-bold whitespace-nowrap">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-live-line text-base"></i>
          </span>
          <span className="hidden sm:inline">实时热议</span>
        </div>
        <div className="ticker-mask flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker">
            {items.map((text, index) => (
              <Link
                key={`${text}-${index}`}
                to="/topics"
                className="px-5 md:px-7 py-3.5 text-xs md:text-sm whitespace-nowrap text-background-50/95 hover:text-accent-300 transition-colors flex items-center gap-2"
              >
                <i className="ri-fire-fill text-accent-300"></i>
                {text}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}